// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"pagination_paginationWrapper__ERcDf"};